module.exports = __webpack_public_path__ + "img/SKMJ_light5.ac40a27b.jpg";